/**
 * auth-profile translations
 * Auto-split from staticTranslations.ts
 */

// ─── Auth Page ─────────────────────────────────────────
export const auth = {
  en: {
    login: "Login", signup: "Sign Up", emailLabel: "Email", passwordLabel: "Password",
    forgotPassword: "Forgot password", loginButton: "Login", loggingIn: "Logging in...",
    or: "or", loginWithGoogle: "Sign in with Google", firstName: "First Name",
    lastName: "Last Name", phoneLabel: "Phone", signupButton: "Sign Up",
    signingUp: "Signing up...", termsOfUse: "Terms of Use", privacyPolicy: "Privacy Policy",
    newCustomerGift: "Gift for new customers!", signupCoupon: "Sign up and get a 15% discount coupon for your first purchase",
    resetPassword: "Reset Password", resetDescription: "Enter your email and we'll send you a reset link",
    sendResetLink: "Send reset link", sendingReset: "Sending...", checkEmail: "Check your inbox",
    emailSentTo: "We sent a verification email to:", clickLink: "Click the link in the email to verify your account",
    checkSpam: "Didn't receive it? Check your spam folder", backToLogin: "Back to login",
    enterNewPassword: "Enter new password", chooseNewPassword: "Choose a new password for your account",
    newPassword: "New Password", confirmPassword: "Confirm Password", updatePassword: "Update Password",
    updating: "Updating...",
    alreadyRegistered: "User already registered", signupError: "An error occurred during signup",
    wrongCredentials: "Wrong email or password", loginError: "An error occurred during login",
    googleError: "Error signing in with Google", accountDisabled: "Your account has been disabled. Please contact support.",
    loggedIn: "Logged in successfully!", resetEmailSent: "Password reset email sent! Check your inbox.",
    resetEmailError: "Error sending email", passwordsNotMatch: "Passwords don't match",
    passwordTooShort: "Password must be at least 6 characters", passwordUpdated: "Password updated successfully!",
    passwordUpdateError: "Error updating password",
  },
  ru: {
    login: "Вход", signup: "Регистрация", emailLabel: "Эл. почта", passwordLabel: "Пароль",
    forgotPassword: "Забыли пароль", loginButton: "Войти", loggingIn: "Входим...",
    or: "или", loginWithGoogle: "Войти через Google", firstName: "Имя",
    lastName: "Фамилия", phoneLabel: "Телефон", signupButton: "Зарегистрироваться",
    signingUp: "Регистрация...", termsOfUse: "Условия использования", privacyPolicy: "Политика конфиденциальности",
    newCustomerGift: "Подарок новым клиентам!", signupCoupon: "Зарегистрируйтесь и получите купон на скидку 15% на первую покупку",
    resetPassword: "Сброс пароля", resetDescription: "Введите email и мы отправим ссылку для сброса",
    sendResetLink: "Отправить ссылку", sendingReset: "Отправка...", checkEmail: "Проверьте почту",
    emailSentTo: "Мы отправили письмо для подтверждения на:", clickLink: "Нажмите на ссылку в письме для подтверждения аккаунта",
    checkSpam: "Не получили? Проверьте папку спам", backToLogin: "Вернуться к входу",
    enterNewPassword: "Введите новый пароль", chooseNewPassword: "Выберите новый пароль для вашего аккаунта",
    newPassword: "Новый пароль", confirmPassword: "Подтверждение пароля", updatePassword: "Обновить пароль",
    updating: "Обновление...",
    alreadyRegistered: "Пользователь уже зарегистрирован", signupError: "Ошибка при регистрации",
    wrongCredentials: "Неверный email или пароль", loginError: "Ошибка при входе",
    googleError: "Ошибка входа через Google", accountDisabled: "Ваш аккаунт заблокирован. Обратитесь в поддержку.",
    loggedIn: "Вход выполнен успешно!", resetEmailSent: "Письмо для сброса пароля отправлено!",
    resetEmailError: "Ошибка отправки письма", passwordsNotMatch: "Пароли не совпадают",
    passwordTooShort: "Пароль должен быть не менее 6 символов", passwordUpdated: "Пароль успешно обновлён!",
    passwordUpdateError: "Ошибка обновления пароля",
  },
  ar: {
    login: "تسجيل الدخول", signup: "إنشاء حساب", emailLabel: "البريد الإلكتروني", passwordLabel: "كلمة المرور",
    forgotPassword: "نسيت كلمة المرور", loginButton: "تسجيل الدخول", loggingIn: "جاري الدخول...",
    or: "أو", loginWithGoogle: "تسجيل الدخول بحساب Google", firstName: "الاسم الأول",
    lastName: "اسم العائلة", phoneLabel: "الهاتف", signupButton: "إنشاء حساب",
    signingUp: "جاري التسجيل...", termsOfUse: "شروط الاستخدام", privacyPolicy: "سياسة الخصوصية",
    newCustomerGift: "هدية للعملاء الجدد!", signupCoupon: "سجّل واحصل على كوبون خصم 15% لأول عملية شراء",
    resetPassword: "إعادة تعيين كلمة المرور", resetDescription: "أدخل بريدك الإلكتروني وسنرسل لك رابط إعادة التعيين",
    sendResetLink: "إرسال رابط إعادة التعيين", sendingReset: "جاري الإرسال...", checkEmail: "تحقق من بريدك",
    emailSentTo: "أرسلنا بريد تحقق إلى:", clickLink: "اضغط على الرابط في البريد لتأكيد حسابك",
    checkSpam: "لم تتلقه؟ تحقق من مجلد البريد العشوائي", backToLogin: "العودة لتسجيل الدخول",
    enterNewPassword: "أدخل كلمة مرور جديدة", chooseNewPassword: "اختر كلمة مرور جديدة لحسابك",
    newPassword: "كلمة مرور جديدة", confirmPassword: "تأكيد كلمة المرور", updatePassword: "تحديث كلمة المرور",
    updating: "جاري التحديث...",
    alreadyRegistered: "المستخدم مسجل بالفعل", signupError: "حدث خطأ أثناء التسجيل",
    wrongCredentials: "بريد إلكتروني أو كلمة مرور خاطئة", loginError: "حدث خطأ أثناء تسجيل الدخول",
    googleError: "خطأ في تسجيل الدخول بحساب Google", accountDisabled: "تم تعطيل حسابك. يرجى الاتصال بالدعم.",
    loggedIn: "تم تسجيل الدخول بنجاح!", resetEmailSent: "تم إرسال بريد إعادة تعيين كلمة المرور!",
    resetEmailError: "خطأ في إرسال البريد", passwordsNotMatch: "كلمتا المرور غير متطابقتين",
    passwordTooShort: "كلمة المرور يجب أن تكون 6 أحرف على الأقل", passwordUpdated: "تم تحديث كلمة المرور بنجاح!",
    passwordUpdateError: "خطأ في تحديث كلمة المرور",
  },
};

// ─── Profile Page ─────────────────────────────────────────
export const profile = {
  en: {
    loading: "Loading...", myAccount: "My Account", tracking: "Tracking",
    personalDetails: "Personal Details", myOrders: "My Orders", favorites: "Favorites",
    repairTracking: "Repair & Delivery Tracking", myMessages: "My Messages",
    backToSite: "Back to Site", logout: "Log Out", loggedOut: "Logged out successfully",
    communication: "Communication", contentManagement: "Content Management",
    operations: "Operations", settingsAndTools: "Settings & Tools",
    contactMessages: "Contact Messages", sendToCustomers: "Send Messages to Customers",
    smsMessages: "SMS Messages", blogManagement: "Blog Management",
    sliderManagement: "Slider Management", promoBanner: "Promo Banner",
    faqManagement: "FAQ Management", repairManagement: "Repair & Order Management",
    userManagement: "User Management", tvDisplay: "Store Display (TV)",
    menuSettings: "Menu Settings", searchSettings: "Search Settings",
    botSettings: "Jewelry Advisor Settings", colorHelper: "Variant Helper",
    firstNameLabel: "First Name", lastNameLabel: "Last Name",
    emailLabel: "Email", phoneLabel: "Phone", birthDate: "Date of Birth",
    save: "Save Changes", saving: "Saving...", saved: "Changes saved successfully",
    changePassword: "Change Password", currentPassword: "Current Password",
    newPassword: "New Password", confirmPassword: "Confirm Password",
    updatePassword: "Update Password", changingPassword: "Changing password...",
    accountDetails: "Account Details", shippingAddress: "Shipping Address",
    streetAddress: "Street & House Number", city: "City", zipCode: "Zip Code",
    profileUpdated: "Profile updated successfully!", profileError: "Error updating profile",
    passwordsNotMatch: "Passwords don't match", passwordTooShort: "Password must be at least 6 characters",
    passwordChanged: "Password changed successfully!", passwordError: "Error changing password",
    moreOptions: "More Options", more: "More",
    // Mobile nav
    main: "Main", orders: "Orders", track: "Tracking",
    accessibilityReport: "Accessibility Report",
  },
  ru: {
    loading: "Загрузка...", myAccount: "Мой аккаунт", tracking: "Отслеживание",
    personalDetails: "Личные данные", myOrders: "Мои заказы", favorites: "Избранное",
    repairTracking: "Отслеживание ремонта и доставки", myMessages: "Мои сообщения",
    backToSite: "Вернуться на сайт", logout: "Выход", loggedOut: "Вы вышли из системы",
    communication: "Коммуникация", contentManagement: "Управление контентом",
    operations: "Операции", settingsAndTools: "Настройки и инструменты",
    contactMessages: "Сообщения контактов", sendToCustomers: "Отправить сообщения клиентам",
    smsMessages: "SMS сообщения", blogManagement: "Управление блогом",
    sliderManagement: "Управление слайдером", promoBanner: "Промо-баннер",
    faqManagement: "Управление FAQ", repairManagement: "Управление ремонтами и заказами",
    userManagement: "Управление пользователями", tvDisplay: "Дисплей магазина (TV)",
    menuSettings: "Настройки меню", searchSettings: "Настройки поиска",
    botSettings: "Настройки советника", colorHelper: "Помощник вариантов",
    firstNameLabel: "Имя", lastNameLabel: "Фамилия",
    emailLabel: "Эл. почта", phoneLabel: "Телефон", birthDate: "Дата рождения",
    save: "Сохранить", saving: "Сохранение...", saved: "Изменения сохранены",
    changePassword: "Изменить пароль", currentPassword: "Текущий пароль",
    newPassword: "Новый пароль", confirmPassword: "Подтверждение пароля",
    updatePassword: "Обновить пароль", changingPassword: "Изменяем пароль...",
    accountDetails: "Данные аккаунта", shippingAddress: "Адрес доставки",
    streetAddress: "Улица и номер дома", city: "Город", zipCode: "Индекс",
    profileUpdated: "Профиль обновлён!", profileError: "Ошибка обновления профиля",
    passwordsNotMatch: "Пароли не совпадают", passwordTooShort: "Пароль минимум 6 символов",
    passwordChanged: "Пароль изменён!", passwordError: "Ошибка изменения пароля",
    moreOptions: "Дополнительные опции", more: "Ещё",
    main: "Главная", orders: "Заказы", track: "Отслеживание",
    accessibilityReport: "Отчёт о доступности",
  },
  ar: {
    loading: "جاري التحميل...", myAccount: "حسابي", tracking: "التتبع",
    personalDetails: "البيانات الشخصية", myOrders: "طلباتي", favorites: "المفضلة",
    repairTracking: "تتبع الإصلاح والتوصيل", myMessages: "رسائلي",
    backToSite: "العودة للموقع", logout: "تسجيل الخروج", loggedOut: "تم تسجيل الخروج بنجاح",
    communication: "التواصل", contentManagement: "إدارة المحتوى",
    operations: "العمليات", settingsAndTools: "الإعدادات والأدوات",
    contactMessages: "رسائل الاتصال", sendToCustomers: "إرسال رسائل للعملاء",
    smsMessages: "رسائل SMS", blogManagement: "إدارة المدونة",
    sliderManagement: "إدارة الشريط", promoBanner: "شريط العروض",
    faqManagement: "إدارة الأسئلة الشائعة", repairManagement: "إدارة الإصلاحات والطلبات",
    userManagement: "إدارة المستخدمين", tvDisplay: "شاشة المتجر (TV)",
    menuSettings: "إعدادات القائمة", searchSettings: "إعدادات البحث",
    botSettings: "إعدادات مستشار المجوهرات", colorHelper: "مساعد المتغيرات",
    firstNameLabel: "الاسم الأول", lastNameLabel: "اسم العائلة",
    emailLabel: "البريد الإلكتروني", phoneLabel: "الهاتف", birthDate: "تاريخ الميلاد",
    save: "حفظ التغييرات", saving: "جاري الحفظ...", saved: "تم حفظ التغييرات بنجاح",
    changePassword: "تغيير كلمة المرور", currentPassword: "كلمة المرور الحالية",
    newPassword: "كلمة مرور جديدة", confirmPassword: "تأكيد كلمة المرور",
    updatePassword: "تحديث كلمة المرور", changingPassword: "جاري تغيير كلمة المرور...",
    accountDetails: "بيانات الحساب", shippingAddress: "عنوان الشحن",
    streetAddress: "الشارع ورقم المنزل", city: "المدينة", zipCode: "الرمز البريدي",
    profileUpdated: "تم تحديث الملف الشخصي!", profileError: "خطأ في تحديث الملف الشخصي",
    passwordsNotMatch: "كلمتا المرور غير متطابقتين", passwordTooShort: "كلمة المرور 6 أحرف على الأقل",
    passwordChanged: "تم تغيير كلمة المرور!", passwordError: "خطأ في تغيير كلمة المرور",
    moreOptions: "خيارات إضافية", more: "المزيد",
    main: "الرئيسية", orders: "الطلبات", track: "التتبع",
    accessibilityReport: "تقرير إمكانية الوصول",
  },
};

// ─── Profile Tour ─────────────────────────────────────────
export const profileTour = {
  en: {
    personalDetails: "Personal Details", personalDetailsDesc: "Here you can edit your personal information, including name, phone, and shipping address.",
    myOrders: "My Orders", myOrdersDesc: "View your order history and easily track your shipments.",
    myFavorites: "My Favorites", myFavoritesDesc: "All the products you marked as favorites are here. You can easily add them to your cart.",
    adminMessages: "Message Management", adminMessagesDesc: "As an admin, you can view and manage all messages sent through the contact form.",
    done: "Done", next: "Next",
  },
  ru: {
    personalDetails: "Личные данные", personalDetailsDesc: "Здесь вы можете редактировать свои данные: имя, телефон и адрес доставки.",
    myOrders: "Мои заказы", myOrdersDesc: "Просматривайте историю заказов и легко отслеживайте доставки.",
    myFavorites: "Мои избранные", myFavoritesDesc: "Все товары, которые вы отметили как избранные, находятся здесь. Легко добавляйте их в корзину.",
    adminMessages: "Управление сообщениями", adminMessagesDesc: "Как администратор, вы можете просматривать и управлять всеми сообщениями контактной формы.",
    done: "Готово", next: "Далее",
  },
  ar: {
    personalDetails: "البيانات الشخصية", personalDetailsDesc: "هنا يمكنك تعديل بياناتك الشخصية، بما في ذلك الاسم والهاتف وعنوان الشحن.",
    myOrders: "طلباتي", myOrdersDesc: "اعرض سجل طلباتك وتتبع شحناتك بسهولة.",
    myFavorites: "المفضلة", myFavoritesDesc: "جميع المنتجات التي حددتها كمفضلة موجودة هنا. يمكنك إضافتها بسهولة إلى السلة.",
    adminMessages: "إدارة الرسائل", adminMessagesDesc: "كمسؤول، يمكنك عرض وإدارة جميع الرسائل المرسلة عبر نموذج الاتصال.",
    done: "تم", next: "التالي",
  },
};

// ─── Profile Greeting ─────────────────────────────────────────
export const profileGreeting = {
  en: { morning: "Good morning", afternoon: "Good afternoon", evening: "Good evening", night: "Good night" },
  ru: { morning: "Доброе утро", afternoon: "Добрый день", evening: "Добрый вечер", night: "Доброй ночи" },
  ar: { morning: "صباح الخير", afternoon: "مساء الخير", evening: "مساء الخير", night: "تصبح على خير" },
};

// ─── Order History ─────────────────────────────────────────
export const orderHistory = {
  en: {
    title: "Order History", ordersCount: "orders", noEmail: "Please log in to see your orders",
    noOrders: "No orders to display", ordersAppearHere: "Orders will appear here after making a purchase",
    retry: "Try Again", reconnectShopify: "Reconnect Shopify", loadError: "Error loading order history",
    reconnectError: "Error reconnecting", quantity: "Qty:", sku: "SKU:",
    shippingAddress: "Shipping address:", shippingMethod: "Shipping method:",
    trackShipment: "Track Shipment", track: "Track", subtotal: "Subtotal",
    shipping: "Shipping", vat: "VAT", discount: "Discount", total: "Total",
    cancelled: "Cancelled", cancelledOn: "Cancelled on", note: "Note:",
    // Status translations
    PENDING: "Pending Payment", AUTHORIZED: "Authorized", PARTIALLY_PAID: "Partially Paid",
    PAID: "Paid", PARTIALLY_REFUNDED: "Partially Refunded", REFUNDED: "Refunded",
    VOIDED: "Voided", EXPIRED: "Expired", UNFULFILLED: "Awaiting Shipment",
    PARTIALLY_FULFILLED: "Partially Shipped", FULFILLED: "Shipped", RESTOCKED: "Restocked",
    ON_HOLD: "On Hold", SCHEDULED: "Scheduled", IN_PROGRESS: "In Progress",
    CUSTOMER: "Customer Request", FRAUD: "Fraud Suspicion", INVENTORY: "Out of Stock",
    DECLINED: "Payment Declined", OTHER: "Other Reason",
    SUCCESS: "Completed", OPEN: "Open", CANCELLED: "Cancelled", ERROR: "Error", FAILURE: "Failed",
  },
  ru: {
    title: "История заказов", ordersCount: "заказов", noEmail: "Войдите, чтобы увидеть заказы",
    noOrders: "Нет заказов для отображения", ordersAppearHere: "Заказы появятся здесь после покупки",
    retry: "Попробовать снова", reconnectShopify: "Переподключить Shopify", loadError: "Ошибка загрузки истории заказов",
    reconnectError: "Ошибка переподключения", quantity: "Кол-во:", sku: "Артикул:",
    shippingAddress: "Адрес доставки:", shippingMethod: "Способ доставки:",
    trackShipment: "Отслеживание доставки", track: "Отследить", subtotal: "Подытог",
    shipping: "Доставка", vat: "НДС", discount: "Скидка", total: "Итого",
    cancelled: "Отменён", cancelledOn: "Отменён", note: "Примечание:",
    PENDING: "Ожидание оплаты", AUTHORIZED: "Авторизован", PARTIALLY_PAID: "Частично оплачен",
    PAID: "Оплачен", PARTIALLY_REFUNDED: "Частично возвращён", REFUNDED: "Возвращён",
    VOIDED: "Аннулирован", EXPIRED: "Истёк", UNFULFILLED: "Ожидает отправки",
    PARTIALLY_FULFILLED: "Частично отправлен", FULFILLED: "Отправлен", RESTOCKED: "Возвращён на склад",
    ON_HOLD: "На удержании", SCHEDULED: "Запланирован", IN_PROGRESS: "В процессе",
    CUSTOMER: "Запрос клиента", FRAUD: "Подозрение в мошенничестве", INVENTORY: "Нет в наличии",
    DECLINED: "Платёж отклонён", OTHER: "Другая причина",
    SUCCESS: "Завершён", OPEN: "Открыт", CANCELLED: "Отменён", ERROR: "Ошибка", FAILURE: "Не удалось",
  },
  ar: {
    title: "سجل الطلبات", ordersCount: "طلبات", noEmail: "سجّل الدخول لعرض طلباتك",
    noOrders: "لا توجد طلبات للعرض", ordersAppearHere: "ستظهر الطلبات هنا بعد إجراء عملية شراء",
    retry: "حاول مرة أخرى", reconnectShopify: "إعادة الاتصال بـ Shopify", loadError: "خطأ في تحميل سجل الطلبات",
    reconnectError: "خطأ في إعادة الاتصال", quantity: "الكمية:", sku: "رمز المنتج:",
    shippingAddress: "عنوان الشحن:", shippingMethod: "طريقة الشحن:",
    trackShipment: "تتبع الشحنة", track: "تتبع", subtotal: "المجموع الفرعي",
    shipping: "الشحن", vat: "ضريبة", discount: "خصم", total: "المجموع",
    cancelled: "ملغى", cancelledOn: "ألغي في", note: "ملاحظة:",
    PENDING: "في انتظار الدفع", AUTHORIZED: "مصرح", PARTIALLY_PAID: "مدفوع جزئياً",
    PAID: "مدفوع", PARTIALLY_REFUNDED: "مسترد جزئياً", REFUNDED: "مسترد",
    VOIDED: "ملغى", EXPIRED: "منتهي الصلاحية", UNFULFILLED: "في انتظار الشحن",
    PARTIALLY_FULFILLED: "شُحن جزئياً", FULFILLED: "تم الشحن", RESTOCKED: "أُعيد للمخزون",
    ON_HOLD: "معلق", SCHEDULED: "مجدول", IN_PROGRESS: "قيد التنفيذ",
    CUSTOMER: "طلب العميل", FRAUD: "اشتباه احتيال", INVENTORY: "نفاد المخزون",
    DECLINED: "دفع مرفوض", OTHER: "سبب آخر",
    SUCCESS: "مكتمل", OPEN: "مفتوح", CANCELLED: "ملغى", ERROR: "خطأ", FAILURE: "فشل",
  },
};

// ─── Favorites Section ─────────────────────────────────────────
export const favorites = {
  en: {
    title: "My Favorites", noFavorites: "You have no favorite products",
    startFavoriting: "Start marking products you like to easily find them here",
    moveAllToCart: "Move All to Cart", clearAll: "Clear All",
    favoriteProduct: "favorite product", favoriteProducts: "favorite products",
    movedToCart: "products moved to cart!", moveError: "Error moving products to cart",
    loadingFavorites: "Loading favorites...",
  },
  ru: {
    title: "Мои избранные", noFavorites: "У вас нет избранных товаров",
    startFavoriting: "Начните отмечать понравившиеся товары, чтобы легко находить их здесь",
    moveAllToCart: "Переместить всё в корзину", clearAll: "Очистить всё",
    favoriteProduct: "избранный товар", favoriteProducts: "избранных товаров",
    movedToCart: "товаров перемещено в корзину!", moveError: "Ошибка перемещения товаров",
    loadingFavorites: "Загрузка избранного...",
  },
  ar: {
    title: "المفضلة", noFavorites: "ليس لديك منتجات مفضلة",
    startFavoriting: "ابدأ بتحديد المنتجات التي تعجبك للعثور عليها بسهولة هنا",
    moveAllToCart: "نقل الكل إلى السلة", clearAll: "مسح الكل",
    favoriteProduct: "منتج مفضل", favoriteProducts: "منتجات مفضلة",
    movedToCart: "منتجات نُقلت إلى السلة!", moveError: "خطأ في نقل المنتجات",
    loadingFavorites: "جاري تحميل المفضلة...",
  },
};

// ─── User Repair Orders ─────────────────────────────────────────
export const repairOrders = {
  en: {
    noOrders: "No orders found", noOrdersDesc: "When you have an order or active repair, you can track it here",
    yourOrders: "Your Orders", ordersFound: "orders found",
    requestNumber: "Request No.", created: "Created:", updated: "Updated:",
    // Status labels
    pending: "Pending", inRepair: "In Repair", waitingInStore: "Waiting in Store",
    completed: "Completed", shipped: "Shipped", delivered: "Delivered", cancelled: "Cancelled",
    // Status descriptions
    pendingDesc: "Your order has been received and is awaiting processing",
    inRepairDesc: "Your jewelry is currently being repaired",
    waitingInStoreDesc: "Repair completed! Your jewelry is waiting for you in the store",
    completedDesc: "Repair completed!", shippedDesc: "Your order has been shipped",
    deliveredDesc: "Your order was delivered successfully", cancelledDesc: "The order was cancelled",
    // Store card
    storePickup: "Store Pickup", storePickupDesc: "You can pick up your order from our store during business hours",
    address: "Address", addressValue: "58 Herzl St., Beer Sheva",
    phone: "Phone", businessHours: "Business Hours",
    sunday: "Sunday: 10:00-19:00", monday: "Monday: 10:00-19:00", tuesday: "Tuesday: 09:45-14:00",
    wednesday: "Wednesday: 10:00-19:00", thursday: "Thursday: 10:00-19:00",
    email: "Email", navigateWaze: "Navigate with Waze", storeLocation: "Store Location",
  },
  ru: {
    noOrders: "Заказы не найдены", noOrdersDesc: "Когда у вас будет заказ или ремонт, вы сможете отслеживать его здесь",
    yourOrders: "Ваши заказы", ordersFound: "заказов найдено",
    requestNumber: "Запрос №", created: "Создан:", updated: "Обновлён:",
    pending: "Ожидание", inRepair: "В ремонте", waitingInStore: "Ожидает в магазине",
    completed: "Завершён", shipped: "Отправлен", delivered: "Доставлен", cancelled: "Отменён",
    pendingDesc: "Ваш заказ получен и ожидает обработки",
    inRepairDesc: "Ваше украшение сейчас в ремонте",
    waitingInStoreDesc: "Ремонт завершён! Ваше украшение ждёт вас в магазине",
    completedDesc: "Ремонт завершён!", shippedDesc: "Ваш заказ отправлен",
    deliveredDesc: "Ваш заказ успешно доставлен", cancelledDesc: "Заказ отменён",
    storePickup: "Самовывоз", storePickupDesc: "Заказ можно забрать из нашего магазина в часы работы",
    address: "Адрес", addressValue: "ул. Герцля 58, Беэр-Шева",
    phone: "Телефон", businessHours: "Часы работы",
    sunday: "Воскресенье: 10:00-19:00", monday: "Понедельник: 10:00-19:00", tuesday: "Вторник: 09:45-14:00",
    wednesday: "Среда: 10:00-19:00", thursday: "Четверг: 10:00-19:00",
    email: "Эл. почта", navigateWaze: "Навигация через Waze", storeLocation: "Расположение магазина",
  },
  ar: {
    noOrders: "لم يتم العثور على طلبات", noOrdersDesc: "عندما يكون لديك طلب أو إصلاح نشط، يمكنك تتبعه هنا",
    yourOrders: "طلباتك", ordersFound: "طلبات وُجدت",
    requestNumber: "طلب رقم", created: "أُنشئ:", updated: "تم التحديث:",
    pending: "قيد الانتظار", inRepair: "قيد الإصلاح", waitingInStore: "في انتظار بالمتجر",
    completed: "مكتمل", shipped: "تم الشحن", delivered: "تم التسليم", cancelled: "ملغى",
    pendingDesc: "تم استلام طلبك وهو في انتظار المعالجة",
    inRepairDesc: "مجوهراتك قيد الإصلاح حالياً",
    waitingInStoreDesc: "اكتمل الإصلاح! مجوهراتك في انتظارك بالمتجر",
    completedDesc: "اكتمل الإصلاح!", shippedDesc: "تم شحن طلبك",
    deliveredDesc: "تم تسليم طلبك بنجاح", cancelledDesc: "تم إلغاء الطلب",
    storePickup: "الاستلام من المتجر", storePickupDesc: "يمكنك استلام طلبك من متجرنا خلال ساعات العمل",
    address: "العنوان", addressValue: "شارع هرتسل 58، بئر السبع",
    phone: "الهاتف", businessHours: "ساعات العمل",
    sunday: "الأحد: 10:00-19:00", monday: "الإثنين: 10:00-19:00", tuesday: "الثلاثاء: 09:45-14:00",
    wednesday: "الأربعاء: 10:00-19:00", thursday: "الخميس: 10:00-19:00",
    email: "البريد الإلكتروني", navigateWaze: "التنقل عبر Waze", storeLocation: "موقع المتجر",
  },
};

// ─── User Messages ─────────────────────────────────────────
export const userMessages = {
  en: {
    title: "My Messages", noMessages: "No messages yet", newBadge: "New",
    attachedFile: "Attached file", newMessage: "You have a new message!",
    loadError: "Error loading messages",
  },
  ru: {
    title: "Мои сообщения", noMessages: "Сообщений пока нет", newBadge: "Новое",
    attachedFile: "Прикреплённый файл", newMessage: "У вас новое сообщение!",
    loadError: "Ошибка загрузки сообщений",
  },
  ar: {
    title: "رسائلي", noMessages: "لا توجد رسائل بعد", newBadge: "جديد",
    attachedFile: "ملف مرفق", newMessage: "لديك رسالة جديدة!",
    loadError: "خطأ في تحميل الرسائل",
  },
};

// ─── Wishlist Login Prompt ─────────────────────────────────────────
export const wishlistPrompt = {
  en: {
    title: "Save to Favorites",
    subtitle: "How would you like to save this product?",
    loginButton: "Log in to account",
    recommended: "(recommended)",
    saveLocally: "Save without logging in",
    savedSuccess: "Product saved to favorites!",
    footerNote: "Logging in allows access to favorites from any device",
  },
  ru: {
    title: "Сохранить в избранное",
    subtitle: "Как вы хотите сохранить этот товар?",
    loginButton: "Войти в аккаунт",
    recommended: "(рекомендуется)",
    saveLocally: "Сохранить без входа",
    savedSuccess: "Товар сохранён в избранное!",
    footerNote: "Вход позволяет получить доступ к избранному с любого устройства",
  },
  ar: {
    title: "حفظ في المفضلة",
    subtitle: "كيف تريد حفظ هذا المنتج؟",
    loginButton: "تسجيل الدخول",
    recommended: "(موصى به)",
    saveLocally: "حفظ بدون تسجيل دخول",
    savedSuccess: "تم حفظ المنتج في المفضلة!",
    footerNote: "تسجيل الدخول يتيح الوصول للمفضلة من أي جهاز",
  },
};
